import React from "react"

import "./loading.css"

const Loading = () => {
    return (
        <div className="spinner">
            <div className="loader loader10"></div>
        </div>
    )
}

export default Loading;